// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#activities{display:flex;gap:40px;flex-direction:row;flex-wrap:wrap;width:100%}@media(max-width:480px){#activities{flex-direction:column;gap:20px}}.as-content{gap:40px}@media(max-width:480px){.as-content{gap:20px}}.try-again{justify-content:space-around;gap:40px}.try-again span{text-align:center}", ""]);
// Exports
module.exports = exports;
